module.exports = __webpack_public_path__ + "img/Easyloono.0e1fdfa1.jpg";